module.exports = __webpack_public_path__ + "media/images/play-9beafab99c790749389cbfd83bc194dc.jpeg";